import { render, staticRenderFns } from "./AuthOTP.vue?vue&type=template&id=070be283&scoped=true&"
import script from "./AuthOTP.vue?vue&type=script&lang=js&"
export * from "./AuthOTP.vue?vue&type=script&lang=js&"
import style0 from "./AuthOTP.vue?vue&type=style&index=0&id=070be283&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070be283",
  null
  
)

export default component.exports